// Hebrew copy + question template for the reviewer programme.
// Editing this file is enough to update what reviewers see —
// no other code change required.

// Default personal letter. Per-reviewer overrides can be saved on the
// invitation row (`letter_md` column); when set, that overrides this default.
// Use {{name}} as a placeholder for the reviewer's first name.
export const DEFAULT_REVIEWER_LETTER = `שלום {{name}},

תודה גדולה שהסכמת לקרוא את הספר עוד לפני יציאתו לציבור. הקריאה שלכם, ההגיגים והחוויה האישית שלכם חשובים לי מאוד — הם יעזרו לי לזקק את הספר לפני שהוא יוצא לאוויר.

הגישה שלכם לספר היא כמובן ללא כל תשלום. כל מה שאני רוצה לבקש הוא שתיקחו את הזמן לקרוא בסבלנות, לבצע את התרגילים, ובסוף — תמלאו את שאלון המשוב הקצר.

תודה,
שלמה

אשמח כמובן לשוחח עם כל אחד ממכם 0544562084 ולקבל משוב גם בעל פה.`;

// Review questions — order matters; add/remove/reorder freely.
// `kind` controls the input type: 'rating' = 1-5 stars; 'text' = free text.
export type ReviewQuestion = {
  id: string;
  kind: "rating" | "text";
  prompt: string;
  hint?: string;
};

export const REVIEW_QUESTIONS: ReviewQuestion[] = [
  {
    id: "overall_rating",
    kind: "rating",
    prompt: "דירוג כולל לספר",
    hint: "1 = לא התחבר/ה, 5 = עשה לי משהו",
  },
  {
    id: "what_resonated",
    kind: "text",
    prompt: "מה הכי דיבר אליכם בספר?",
  },
  {
    id: "what_missed",
    kind: "text",
    prompt: "מה הרגיש פחות חזק / חסר / לא ברור?",
  },
  {
    id: "exercises_experience",
    kind: "text",
    prompt: "האם ביצעתם את התרגילים בפועל? איך זה הרגיש?",
  },
  {
    id: "memorable_chapters",
    kind: "text",
    prompt: "אילו פרקים זכורים לכם במיוחד?",
  },
  {
    id: "would_recommend",
    kind: "text",
    prompt: "האם תמליצו על הספר? למי?",
  },
  {
    id: "free_notes",
    kind: "text",
    prompt: "הערות, רעיונות, או כל דבר שעולה",
  },
];

export const expandLetter = (letter: string, name: string) =>
  letter.replace(/\{\{\s*name\s*\}\}/g, name);
